import { render, staticRenderFns } from "./linkCardContainer.vue?vue&type=template&id=56fa3e80&"
import script from "./linkCardContainer.vue?vue&type=script&lang=js&"
export * from "./linkCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports